class TextMCQMaxLengthValidator {
    /**
     * Constructs a new TextMCQMaxLengthValidator instance.
     * @param {Object} $injector - The AngularJS injector service.
     * @param {jQuery} $ - The jQuery object.
     */
    constructor($injector, $) {
        this.$injector = $injector;
        this.$ = $;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.LOGIC.TEXT-MCQ-INPUT-FIELD-WITHOUT-MAXLENGTH';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Retrieves the $translate service from the injector, initializing it if necessary.
     * @returns {Object} The $translate service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model to ensure all text input fields have a valid maxLength attribute.
     * @param {Object} model - The model to validate.
     * @returns {Object} The validation result.
     */
    validate(model) {
        let error = false;

        // Create a jQuery object from the model's content
        const el = this.$('<div/>').html(model.getContent());
        const textInputEls = el.find("input[type='text']");

        textInputEls.each((idx, textInputEl) => {
            const ml = this.$(textInputEl).attr('maxlength');
            // Check if maxlength is undefined or not a number
            if (typeof ml === 'undefined' || isNaN(parseInt(ml))) {
                error = true;
            }
        });

        return {
            'onSheetBlur': false,
            'onlyBanner': false,
            'validator': this.getValidatorName(),
            'modelUUID': model.getUUID(),
            'error': error,
            'status': error ? 'WARNING' : 'SUCCESS', // WARNING | DANGER | SUCCESS
            'message': this.getErrorMessage(model),
            'message_template': false,
            'callbacks': [
                'validationDisplayObjectHeader-' + model.getUUID()
            ]
        };
    }

    /**
     * Constructs and returns the error message for the validation.
     * @param {Object} model - The model being validated.
     * @returns {string} The error message.
     */
    getErrorMessage(model) {
        const questionHeadline = model.getQuestionHeadline();
        this._message = this.$translate(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Returns the forced check status.
     * @returns {boolean} The forced check status.
     */
    get forcedCheck() {
        return this._forced_check;
    }

    /**
     * Returns the name of the validator.
     * @returns {string} The validator name.
     */
    getValidatorName() {
        return 'TextMCQMaxLengthValidator';
    }
}

export default TextMCQMaxLengthValidator;